import Model from "./Model";

class Tags extends Model {
    getId() {
        return this.attrs.id;
    }
    
    setId(value) {
        this.attrs.id = value;
        return this;
    }
    getName() {
        return this.attrs.name;
    }
    
    setName(value) {
        this.attrs.name = value;
        return this;
    }
    getColor() {
        return this.attrs.color;
    }
    
    setColor(value) {
        this.attrs.color = value;
        return this;
    }
    getDescription() {
        return this.attrs.description;
    }
    
    setDescription(value) {
        this.attrs.description = value;
        return this;
    }
    getContactsCount() {
        return this.attrs.contactsCount;
    }
    
    setContactsCount(value) {
        this.attrs.contactsCount = value;
        return this;
    }
    getCreatedAt() {
        return this.attrs.createdAt;
    }
    
    setCreatedAt(value) {
        this.attrs.createdAt = value;
        return this;
    }
    getUpdatedAt() {
        return this.attrs.updatedAt;
    }
    
    setUpdatedAt(value) {
        this.attrs.updatedAt = value;
        return this;
    }
}
export default Tags;